import React from "react";
import { Stack, Link as MuiLink, Typography } from "@mui/material";
import { useSelector } from "react-redux";

import { useTranslation } from "hooks/use-translation";
import { DRAWER_WIDTH_SM } from "features/sidebar/constants";
import { AskFilled } from "./icons/filled/ask";

export function DashboardGuideFooter() {
  const { t } = useTranslation();
  const selectedClient = useSelector(
    (state) => state.ReducerClients.selectedClient
  );

  if (!selectedClient) return null;

  return (
    <Stack
      position="fixed"
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{
        pl: (theme) => `calc(${DRAWER_WIDTH_SM}px + ${theme.spacing(2.5)})`,
        pr: 2.5,
        height: "30px",
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "#f2f2f2",
      }}
    >
      <MuiLink
        href="https://laborsolutionsit.atlassian.net/servicedesk/customer/portals"
        target="_blank"
        underline="none"
      >
        <Stack alignItems="center" direction="row" spacing={0.5}>
          <AskFilled sx={{ fontSize: 16 }} />
          <Typography variant="caption">
            {t("DIC_FOOTER_HELP_CENTER_TEXT")}
          </Typography>
        </Stack>
      </MuiLink>
    </Stack>
  );
}
